export default {
	//将css的px后缀删除并转换为数字，例如： 10px --> 10
	removeCssPX: function(value) {
		if (value == null || value == "") {
			return 0;
		} else {
			//去除末尾的px，转化为number格式
			return parseFloat(value.substr(0, value.length - 2));
		}
	},

	//阻止事件冒泡及默认事件
	clearEventBubble: function(e) {
        if(e == null){
            return;
        }
		if(e.stopPropagation) {
			e.stopPropagation();
		}else{
			e.cancelBubble = true;
		}
		if(e.preventDefault){
			e.preventDefault
		}else{
			e.returnValue = false;
		}
	},
	   
	/** 
	 *根据传入data生成表格数据
	 *option=[{key:'对应data字段'，value:'表头字段名称'}]
	*/
   	createTable(option,data){
		let W =Math.floor((1/option.length)*100)+'%' 
		let top = `<table border="1" style="text-align: center;border-collapse: collapse;" width="100%" id="myTable">
						<thead style='border: 1px solid #EBEEF5;font-size:14px;color: #909399;font-weight: normal;'>`
		//生成表头thead
		let cHead = '<tr >'
		option.forEach(item=>{
			cHead+=`<th style='padding: 5px 0;width:${W};word-break:break-all'>${item.value}</th>`
		})
		cHead+='</tr></thead>'

		//生成tboady
		let cBoady = `<tbody style='border: 1px solid #EBEEF5;font-size:12px;color: #909399;font-weight: normal;'>`
		data.forEach(item=>{
			cBoady+=`<tr >`
			option.forEach((k,index)=>{
				cBoady+=`<th style='padding: 5px 0;width:${W};word-break:break-all'>${item[k.key]}</th>`
				// 	if(item.rowspan[0]==index){
				// 		str += `rowspan = ${item.rowspan[1]} `
				// 	}
				// 	cBoady+=`<th style='padding: 5px 0;width:${W};word-break:break-all' ${str} >${item[k.key]}</th>`
				// }else if(item.colspan && !item.rowspan){
				// 	let str = ''
				// 	if(item.colspan[0]==index){
				// 		str += `colspan = ${item.colspan[1]} `
				// 	}
				// 	cBoady+=`<th style='padding: 5px 0;width:${W};word-break:break-all' ${str} >${item[k.key]}</th>`
				// }else if(!item.colspan && item.rowspan){
				// 	let str = ''
				// 	if(item.rowspan[0]==index){
				// 		str += `rowspan = ${item.rowspan[1]} `
				// 	}
				// 	cBoady+=`<th style='padding: 5px 0;width:${W};word-break:break-all' ${str} >${item[k.key]}</th>`
				// }else{
					// cBoady+=`<th style='padding: 5px 0;width:${W};word-break:break-all'>${item[k.key]}</th>`
				// }
				
			})
			cBoady+=`</tr>`
		})
		cBoady+=`</tbody></table>`
		return top+cHead+cBoady
	},

 	// 时间戳转换为1990-01-01 00:00:00格式
    timestampToDate(timestamp, data) {
        //data存在返回年月日，如果不存在返回年月日时分秒
        if(timestamp == null){
            return "";
        }
        let tampDate = new Date(timestamp);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let offSet = tampDate.getTimezoneOffset() //返回格林威治时间和本地时间之间的时差，以分钟为单位。
        let tampOffSet  = Math.round((480 +offSet)*60*1000)
        const date = new Date(timestamp-tampOffSet)
        const Y = `${date.getFullYear()}-`;
        const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
        const D = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
        const h = date.getHours() < 10 ? `0${date.getHours()}:` : `${date.getHours()}:`;
        const m = date.getMinutes() < 10 ? `0${date.getMinutes()}:` : `${date.getMinutes()}:`;
        const s = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
        if(data){
            return Y + M + D
        }else{
            return Y + M + D +' '+ h + m + s;
        }

	},
	// 时间戳转换为1990-01-01 00:00:00格式
    timestampToDate3(timestamp, data) {
        //data存在返回年月日，如果不存在返回年月日时分秒
        if(timestamp == null){
            return "";
        }
        let tampDate = new Date(timestamp);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let offSet = tampDate.getTimezoneOffset() //返回格林威治时间和本地时间之间的时差，以分钟为单位。
        let tampOffSet  = Math.round((480 +offSet)*60*1000)
        const date = new Date(timestamp-tampOffSet)
        const Y = `${date.getFullYear()}-`;
        const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
        const D = date.getDate() < 10 ? `0${date.getDate()} ` : `${date.getDate()} `;
        const h = date.getHours() < 10 ? `0${date.getHours()}时` : `${date.getHours()}时`;
        const m = date.getMinutes() < 10 ? `0${date.getMinutes()}:` : `${date.getMinutes()}:`;
        const s = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
       
            return Y + M + D+h
     

	},
	timestampToDate2(timestamp, data) {
		//data存在返回年月日，如果不存在返回年月日时分秒
		if(timestamp == null){
			return "";
		}
		let tampDate = new Date(timestamp);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
		let offSet = tampDate.getTimezoneOffset() //返回格林威治时间和本地时间之间的时差，以分钟为单位。
		let tampOffSet  = Math.round((480 +offSet)*60*1000)
		const date = new Date(timestamp-tampOffSet)
		const Y = `${date.getFullYear()}`;
		const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}`;
		const D = date.getDate() < 10 ? `0${date.getDate()} ` : `${date.getDate()}`;
		const h = date.getHours() < 10 ? `0${date.getHours()}` : `${date.getHours()}`;
		const m = date.getMinutes() < 10 ? `0${date.getMinutes()}` : `${date.getMinutes()}`;
		const s = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
		if(data){
			return `${D}-${M}-${Y} ${h}:${m}:${s}`
		}else{
			return `${Y}-${M}-${D} ${h}:${m}:${s}`;
		}
	},
	//将传入的秒根据大小转换成合理的单位显示
    secondToDate(s){
		let num = Number(s)
		if(num>0){
			num = Number.parseInt(s)
			if(num<60){
				return num+'秒'
			}else if(num<60*60){
				let M =Number.parseInt(num/60)
				let S = num%60
				return S?`${M}分${S}秒`:`${M}分`
			}else {
				let H = Number.parseInt(num/3600)
				let M = Number.parseInt((num%3600)/60)
				return M?`${H}小时${M}分`:`${H}小时`
			}
			// }else{
			// let D = Number.parseInt(num/(3600*24))
			// let H = Number.parseInt((num%(3600*24))/3600)
			// 	return H?`${D}天${H}小时`:`${D}天`
			// }
		}else{
			return ''
		}
    },
   
	//返回一段日期里面的每一天
	formatEveryDay(start, end) {
		let dateList = []; 
		var startTime = this.getDate(start);
		var endTime = this.getDate(end);
	
		while ((endTime.getTime() - startTime.getTime()) >= 0) {
			var year = startTime.getFullYear();
			var month = startTime.getMonth() + 1 < 10 ? '0' + (startTime.getMonth() + 1) : startTime.getMonth() + 1;
			var day = startTime.getDate().toString().length == 1 ? "0" + startTime.getDate() : startTime.getDate();
			dateList.push(year + "-" + month + "-" + day); 
			startTime.setDate(startTime.getDate() + 1);
		}
		return dateList;
	},
  
	getDate(datestr) {
		var temp = datestr.split("-");
		var date = new Date(temp[0], temp[1] - 1, temp[2]);
		return date;
	},

	// 格式化时间，获取两个日期之间所有月份
	getMonthBetween(start, end) { //传入的格式YYYY-MM
		let dateList = []; // 时间格式 ‘2019-04-01’
		let dateList2 = []; // 时间格式 ‘2019-04’ 
		var s = start.split("-");
		var e = end.split("-");
		var min = new Date();
		var max = new Date();
		min.setFullYear(s[0], s[1] * 1 - 1, 1); // 开始日期
		max.setFullYear(e[0], e[1] * 1 - 1, 1); // 结束日期
		var current = min;
		while (current <= max) {
			var year = current.getFullYear();
			var month = current.getMonth() + 1 < 10 ? '0' + (current.getMonth() + 1) : current.getMonth() + 1;
			dateList.push(year + "-" + month + "-" + '01');
			dateList2.push(year + "-" + month); 
			current.setMonth(month);
		}
		return [dateList, dateList2];
	},
	
	getMonthDay(start, end,w){
		let [dateList, dateList2] = this.getMonthBetween(start, end)
		let arr = []
		let dayList = this.formatEveryDay(start, end)
		dateList2.forEach((item,index)=>{
			arr[index] = {
				month:item,
				dayList:dayList.filter(d=>d.includes(item))
			}
		})
		let len = dayList.length
		let showHours = false
		//小于4天显示小时
		if(dayList.length<=3||w){
			let index = 6
			arr = dayList.map(item=>{
				if(w>=100){
					index = 24
					return {
						month:item,
						dayList:['0:00 - 1:00','1:00 - 2:00','2:00 - 3:00','3:00 - 4:00','4:00 - 5:00','5:00 - 6:00','6:00 - 7:00','7:00 - 8:00',
						'8:00 - 9:00','9:00 - 10:00','10:00 - 11:00','11:00 - 12:00','12:00 - 13:00','13:00 - 14:00','14:00 - 15:00','15:00 - 16:00',
						'16:00 - 17:00','17:00 - 18:00','18:00 - 19:00','19:00 - 20:00','20:00 - 21:00','21:00 - 22:00','22:00 - 23:00','23:00 - 24:00',],
					}
					
				}
				
				if(w>=85){
					index = 12
					return {
						month:item,
						dayList:['0 - 2时','2 - 4时','4 - 6时','6 - 8时','8 - 10时','10 - 12时','12 - 14时','14 - 16时','16 - 18时','18 - 20时','20 - 22时','22 - 24时'],
					}
				}

				return {
					month:item,
					dayList:['0 - 4时','4 - 8时','8 - 12时','12 - 16时','16 - 20时','20 - 24时'],
				}
			})
			len = dayList.length*index
			showHours = true
		}
		return {
			monthDay:arr,
			len,
			showHours
		}
	},

	getPDI(){
		var arrDPI = new Array;
        if (window.screen.deviceXDPI) {
            arrDPI[0] = window.screen.deviceXDPI;
            arrDPI[1] = window.screen.deviceYDPI;
        } else {
            var tmpNode = document.createElement("DIV");
            tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
            document.body.appendChild(tmpNode);
            arrDPI[0] = parseInt(tmpNode.offsetWidth);
            arrDPI[1] = parseInt(tmpNode.offsetHeight);
            tmpNode.parentNode.removeChild(tmpNode);
        }
        return arrDPI;
	},

	//像素转成毫米
	px2mm(value){  
		var inch = value/this.getPDI()[0];
        var c_value = inch * 25.4;
        return c_value;
	},

	//毫米转换成像素
	mm2px(value){
		var inch = value/25.4;
        var c_value = inch*this.getPDI()[0];
        return c_value;
	},

    // 将时间格式字符串转换为UTC时间
    translateTimeStrToUTC(timeStr){
        //获取与UTC的时间差
        const offset = new Date().getTimezoneOffset() * 60 * 1000;
        //要转换的时间
        let localTime;
        if(timeStr == null || timeStr == ""){
            localTime = new Date().getTime();
        }else{
            localTime = new Date(timeStr).getTime();
        }
        // UTC时间 = 本地时间 + 时差
        return this.timestampToDate(localTime + offset);
	},
	
    //计算中英文字符串长度(英文占1个字符，中文汉字占2个字符)
    strlen(str){
    	let len = 0;
    	for(let i=0 ;i<str.length; i++){
    		let c = str.charCodeAt(i);
    		if((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)){
    			len++;
    		}else{
    			len+=2;
    		}
    	}
    	return len;
	},
	
    //对象克隆_实现只传值不传引用
    cloneObj(obj){
		var str, newobj = obj.constructor === Array ? [] : {};
		if(typeof obj !== 'object'){
			return;
		} else if(window.JSON) {
			str = JSON.stringify(obj), //序列化对象
			newobj = JSON.parse(str); //还原
		} else {
			for(var i in obj){
				newobj[i] = typeof obj[i] === 'object' ? cloneObj(obj[i]) : obj[i];
			}
		}
		return newobj;
	  },
	  
	//比较两个对象是否相等
	compareObj(x, y) {
		// If both x and y are null or undefined and exactly the same
		if (x === y) {
			return true;
		}

		// If they are not strictly equal, they both need to be Objects
		if (!(x instanceof Object) || !(y instanceof Object)) {
			return false;
		}

		//They must have the exact same prototype chain,the closest we can do is
		//test the constructor.
		if (x.constructor !== y.constructor) {
			return false;
		}

		for (var p in x) {
			//Inherited properties were tested using x.constructor === y.constructor
			if (x.hasOwnProperty(p)) {
				// Allows comparing x[ p ] and y[ p ] when set to undefined
				if (!y.hasOwnProperty(p)) {
					return false;
				}

				// If they have the same strict value or identity then they are equal
				if (x[p] === y[p]) {
					continue;
				}

				// Numbers, Strings, Functions, Booleans must be strictly equal
				if (typeof (x[p]) !== "object") {
					return false;
				}

				// Objects and Arrays must be tested recursively
				if (!Object.equals(x[p], y[p])) {
					return false;
				}
			}
		}

		for (p in y) {
			// allows x[ p ] to be set to undefined
			if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
				return false;
			}
		}
		return true;
	},
	//检测json是否为{}
	isEmptyObject(obj){  
		var jsonLength=0;
		for (var i in obj){
			jsonLength++;
		}
		return jsonLength==0  
   	}, 
	//将下划线命名转成驼峰命名法
	toHump(name) {
		return name.replace(/\_(\w)/g, function (all, letter) {
			return letter.toUpperCase();
		});
	},

	// 驼峰转换下划线
	toLine(name) {
		return name.replace(/([A-Z])/g, "_$1").toLowerCase();
	}
}



// WEBPACK FOOTER //
// ./src/util/CommonUtils.js